export function chartApiUrl(path: string, variation?: string): string {
  if (!variation || variation === "undefined") {
    return path;
  }
  return `${path}?variation=${encodeURIComponent(variation)}`;
}
